module.exports = __webpack_public_path__ + "fc6db6cbefd400316a23d26f009f7fe9.MP3";